import { AccessTime } from '@mui/icons-material';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { formatDuration, intervalToDuration } from 'date-fns';
import React, { FC, MouseEventHandler, useState } from 'react';
import { useDialog } from '../../Dialog';
import { useOnMount } from '../../utils';
import { useStyles } from './styles';

const INTERVAL_DECREMENT = 1000; // 1s

interface TimeoutDialogProps {
  timerStart: number;
  lockTimeout: number;
  onNavigateBack?: MouseEventHandler<HTMLButtonElement>;
  disableLockForV0?: boolean;
}

export const TimeoutDialog: FC<TimeoutDialogProps> = ({
  timerStart,
  lockTimeout,
  onNavigateBack,
  disableLockForV0,
}) => {
  const classes = useStyles();
  const [timer, setTimer] = useState(timerStart);
  const { closeDialog } = useDialog();

  useOnMount(() => {
    const interval = setInterval(() => {
      setTimer((prev) =>
        prev - INTERVAL_DECREMENT >= 0 ? prev - INTERVAL_DECREMENT : 0,
      );
    }, INTERVAL_DECREMENT);

    return () => clearInterval(interval);
  });

  return (
    <>
      <DialogTitle>Période d'inactivité</DialogTitle>
      <DialogContent className={classes.content}>
        <AccessTime className={classes.icon} />
        <div>
          {timer ? (
            <DialogContentText>
              Sans action de votre part, cette page ne sera plus{' '}
              {disableLockForV0 ? 'en cours de modification' : 'vérrouillée'}{' '}
              dans
              <span className={classes.timer}>{Math.round(timer / 1000)}</span>
              secondes.
            </DialogContentText>
          ) : (
            <>
              <DialogContentText className={classes.paragraph}>
                En raison d'une période d'inactivité de{' '}
                {formatDuration(
                  intervalToDuration({
                    start: 0,
                    end: lockTimeout,
                  }),
                )}
                , cette page n'est plus{' '}
                {disableLockForV0 ? "en cours d'édition" : 'verrouillée'}.
              </DialogContentText>
              <DialogContentText>
                Vous pouvez{' '}
                {disableLockForV0
                  ? 'continuer de la modifier'
                  : 'la verrouiller à nouveau'}{' '}
                si personne d'autre n'est déjà en train de la modifier.
              </DialogContentText>
            </>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        {onNavigateBack && (
          <Button
            onClick={(e) => {
              closeDialog();
              onNavigateBack?.(e);
            }}
            color="primary"
          >
            Retour à la liste
          </Button>
        )}
        <Button onClick={closeDialog} color="primary" variant="contained">
          Rester sur la page
        </Button>
      </DialogActions>
    </>
  );
};
